/** @format — Optional session cache for AG-UI turns (not used for history hydration) */

import { normalizeAguiComponents } from "@/features/chat-agui/normalizeComponents";

const STORAGE_KEY = "dockie_chat_agui_ui_v2";
const MAX_TURNS_PER_CHAT = 80;

function readStore() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function writeStore(store) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    /* quota */
  }
}

/** Append one agent turn snapshot (call when a stream turn finishes). */
export function appendAguiTurnCache(chatId, { uiComponents, text = "" }) {
  const id = String(chatId ?? "").trim();
  if (!id || id.startsWith("temp_")) return;

  const normalized = normalizeAguiComponents(uiComponents);
  if (!normalized.length) return;

  const store = readStore();
  const entry = store[id] ?? { turns: [] };
  entry.turns = [
    ...entry.turns,
    {
      uiComponents: normalized,
      text: String(text ?? "").slice(0, 240),
      savedAt: Date.now(),
    },
  ].slice(-MAX_TURNS_PER_CHAT);
  store[id] = entry;
  writeStore(store);
}

/** Merge cached ui_components onto agent rows missing them (by turn order). */
export function applyAguiTurnCache(chatId, messages = []) {
  const id = String(chatId ?? "").trim();
  if (!id) return messages;

  const turns = readStore()[id]?.turns;
  if (!Array.isArray(turns) || !turns.length) return messages;

  let turnIdx = 0;
  return messages.map((m) => {
    if (m.role !== "agent" || (m.uiComponents?.length ?? 0) > 0) return m;
    const snap = turns[turnIdx++];
    if (!snap?.uiComponents?.length) return m;
    return {
      ...m,
      uiComponents: snap.uiComponents,
      isAgui: true,
    };
  });
}

export function clearAguiTurnCache(chatId) {
  const id = String(chatId ?? "").trim();
  if (!id) return;
  const store = readStore();
  if (store[id]) {
    delete store[id];
    writeStore(store);
  }
}
